import mongoose from "mongoose";

export interface EmailLog {
  _id: mongoose.Schema.Types.ObjectId;
  to: string[];
  cc: string[];
  bcc: string[];
  template: string;
  customerId?: string; // from locals, for searching
  locals?: string; // stringified json or null
  createdAt: Date;
}

export const EmailLogSchema = new mongoose.Schema<EmailLog>({
  to: { type: [String], required: true },
  cc: { type: [String], required: true },
  bcc: { type: [String], required: true },
  template: { type: String, required: true, index: true },
  customerId: { type: String, index: true },
  locals: String,
  createdAt: { type: Date, expires: 86400 * 7, default: Date.now }, // 7 days
});

export const filterProps: (keyof EmailLog)[] = [
  "template",
  "customerId",
];

export const emailLogUtils = {
  filterProps
};
